import DialogComponent from "components/Dialog";

export default class CancelInvoiceDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general"
        };
    }

    title = "directionType.cancel";

    show(info, hideCb) {
        this.info = info;
        this.hidCb = hideCb;

        this.dialogTitle = "directionType.cancel";
        this.dialogSaveLabel = "main.confirm";
        super.show();
    }

    onShow() {
    }

    save() {
        const cancelComment = this.commentInput.value;
        if (!cancelComment)
            return;

        if (this.hidCb?.apply)
            this.hidCb({
                id: this.info.id,
                workItemId: this.info.workItemId,
                cancelComment,
            }, this.info.id);

        this.hide();
    }

    renderContent() {
        return (
            <div className="content flex col gap16">
                <div className="text p1">Укажите причину отмены счета</div>
                {this.insertInput({
                    ref: el => this.commentInput = el,
                    label: "client.comment",
                    placeHolder: "client.comment",
                })}
            </div>
        );
    }
}

